import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { armoryService } from '../../../services/central-api/armory';
import { translate } from '../../../services/translate';
import moment from 'moment';


interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    disabled: boolean;
    semiBoldLabel?: boolean;
}

function ArmoryShiftDropdown({ value, setValue, zIndex, disabled, semiBoldLabel = false }: Props) {
    const [selectableItems, setSelectableItems] = useState<{ label: string; value: number; }[]>([]);

    async function getItems() {
        try {
            const items = await armoryService.getArmourerShifts();
            setSelectableItems([
                ...items.map((item) => {
                    return {
                        value: item.id,
                        label: `${moment(item.estimatedStart).format('DD/MM/YYYY HH:mm')} - ${moment(item.estimatedFinish).format('DD/MM/YYYY HH:mm')}`
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    return (
        <FilterDropdown
            label={translate('shiftsOfAction')}
            items={selectableItems}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelFontSize={14}
            semiBoldLabel={semiBoldLabel}
            disabled={disabled}
        />
    );
}

export default ArmoryShiftDropdown;
